import React, { useEffect, useRef, useState } from "react";

//import  from '';

export default function useTimeOut(props) {
  const { enabled, duration, onTimeOut } = props;

  const timeOutRef = useRef(null);

  const [timeOutCount, setTimeOutCount] = useState(0);

  const reset = () => {
    setTimeOutCount(0);
    clearTimeout(timeOutRef.current);
  };

  useEffect(() => {
    if (!enabled) {
      clearTimeout(timeOutRef.current);
      return;
    }

    timeOutRef.current = setTimeout(() => {
      setTimeOutCount((t) => t + 1);
    }, duration);

    return () => {
      clearTimeout(timeOutRef.current);
    };
  }, [enabled, timeOutCount]);

  useEffect(() => {
    enabled &&
      timeOutCount &&
      typeof onTimeOut === "function" &&
      onTimeOut(timeOutCount);
  }, [timeOutCount]);

  return {
    reset,
    timeOut: timeOutCount,
  };
}

useTimeOut.propTypes = {};

useTimeOut.defaultProps = {};
